import type { MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';

import { SeoSlugEnum } from '@rover/constants/src/search/seo.constants';

type DatePickerPlaceholders = Record<
  Exclude<
    SeoSlugEnum,
    SeoSlugEnum.DOG_TRAINING | SeoSlugEnum.DOG_SITTING | SeoSlugEnum.PET_BOARDING
  >,
  MessageDescriptor
>;

export const DATE_PICKER_START_PLACEHOLDER_FOR_SEO_SLUG: DatePickerPlaceholders = {
  [SeoSlugEnum.DOG_BOARDING]: msg`Drop off`,
  [SeoSlugEnum.DOG_WALKING]: msg`Start`,
  [SeoSlugEnum.DOGGY_DAY_CARE]: msg`Start`,
  [SeoSlugEnum.HOUSE_SITTING]: msg`Start`,
  [SeoSlugEnum.CAT_SITTING]: msg`Start`,
  [SeoSlugEnum.PET_SITTING]: msg`Start`,
};

export const DATE_PICKER_END_PLACEHOLDER_FOR_SEO_SLUG: DatePickerPlaceholders = {
  [SeoSlugEnum.DOG_BOARDING]: msg`Pick up`,
  [SeoSlugEnum.DOG_WALKING]: msg`End`,
  [SeoSlugEnum.DOGGY_DAY_CARE]: msg`End`,
  [SeoSlugEnum.HOUSE_SITTING]: msg`End`,
  [SeoSlugEnum.CAT_SITTING]: msg`End`,
  [SeoSlugEnum.PET_SITTING]: msg`End`,
};
